var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('h1', {
    staticClass: "text-h2 primary--text font-weight-bold text-center mb-8"
  }, [_vm._v("Library Services")]), _c('v-row', {
    staticClass: "my-16",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_vm._l(_vm.links, function (link) {
    return _c('v-col', {
      key: link.key,
      attrs: {
        "cols": "11",
        "md": "5"
      }
    }, [_c('v-card', {
      attrs: {
        "hover": "",
        "to": ("/services/" + (link.slug))
      }
    }, [_c('v-card-text', {
      staticClass: "d-flex align-center font-weight-bold primary--text text-h6"
    }, [_c('v-icon', {
      staticClass: "mr-4",
      attrs: {
        "color": "primary",
        "x-large": ""
      }
    }, [_vm._v("mdi " + _vm._s(link.icon))]), _vm._v(" " + _vm._s(link.label))], 1)], 1)], 1);
  }), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "5"
    }
  })], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }